'use strict';
const Backbone = require('backbone');
const Moment = require('moment');

module.exports = Backbone.Model.extend({
    defaults: {
        target: null,
        versions: [],
        _repository: null,  // work repository
    },

    initialize: function() {
        this.listenTo(this.getTarget(), 'change:deleted', this.delete);
    },

    path: function() {
        return `data/${this.id}`;
    },

    toJSON: function() {
        let j = this.constructor.__super__.toJSON.call(this);
        delete j._repository;
        return j;
    },

    getName: function() {
        throw 'Not Implemented!';
    },

    getProject: function() {
        return this.get('_project');
    },

    getVersions: function() {
        return this.get('versions');
    },

    getLatestVersion: function() {
        return _.sortBy(this.getVersions(), v => - Moment(v.updatedAt))[0];
    },

    getTarget: function() {
        return this.get('target');
    },

    delete: function() {
        this.set('deleted', true);
    },

    isDeleted: function() {
        return this.get('deleted');
    }
});



// WEBPACK FOOTER //
// ./process/domain/entity/work/index.js